import React, { useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useScreenRecording } from 'components/ScreenRecordingScheduler';
import {
  canUseNotifications,
  requestNotificationPermission,
} from 'utils/screenShareReminder';

const ScreenRecordingBanner = () => {
  const {
    status,
    startRecording,
    isPunchedOut,
    supportsCapture,
    openWfh,
  } = useScreenRecording();

  useEffect(() => {
    if (!isPunchedOut && openWfh && canUseNotifications()) {
      requestNotificationPermission();
    }
  }, [isPunchedOut, openWfh?.id]);

  if (isPunchedOut || !openWfh) {
    return null;
  }

  if (!supportsCapture) {
    return (
      <Alert variant="info" className="mb-3">
        Please open HR Portal on your work computer to share your screen.
      </Alert>
    );
  }

  if (status === 'capturing') {
    return (
      <Alert variant="success" className="mb-3">
        Screen share is on. Keep this page open until you punch out.
      </Alert>
    );
  }

  if (status === 'elsewhere') {
    return (
      <Alert variant="warning" className="mb-3">
        Screen share is already on another device.
      </Alert>
    );
  }

  return (
    <Alert variant="warning" className="mb-3">
      <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
        <div>
          Please share your screen on your work computer.
        </div>
        <Button variant="primary" className="text-nowrap" onClick={startRecording}>
          Share screen
        </Button>
      </div>
    </Alert>
  );
};

export default ScreenRecordingBanner;
